import React from 'react';

import { RadioWithLabel, RadioInput, RadioLabel, Typography } from '@hpstellar/core';

import withWindowResize from '../../ui/components/window-resize';
import Icon from '../../ui/components/icon';
import { withError } from '../../shared/components/error-boundary';
import SearchDrawer from '../../search-filter/components/search-drawer';
import VWAFilterCount from '../../plp/components-v2/vwa-filter-count';
import FilterMenu from '../../filters';

const SaleMobileSort = ({ options, sortValue, closeModal, setSort }) => {
    const handleChange = index => () => {
        closeModal();
        setSort(options[index].value);
    };
    return (
        <div>
            {options.map((sort, index) => {
                const checked = sort.value === sortValue;
                return (
                    <RadioWithLabel
                        key={sort.label}
                        checked={checked}
                        data-metrics-event="e_facet"
                        data-metrics-event-name="sortBy"
                        data-metrics-sort-type={sort.label && sort.label.toLowerCase().replace(/\s/gi, '-')}
                    >
                        <RadioLabel>
                            <Typography>{sort.label}</Typography>
                            <RadioInput checked={checked} value={index} onChange={handleChange(index)} />
                        </RadioLabel>
                    </RadioWithLabel>
                );
            })}
        </div>
    );
};

function SaleFilters({
    label = 'SORT & FILTER',
    sortOptions,
    defaultExpandedFilters,
    setSort,
    sortValue,
    resultCount,
}) {
    return (
        <SearchDrawer label={label} className={'slp-mobile-filters'} resultCount={resultCount}>
            {({ closeDrawer }) => {
                return (
                    <>
                        <div className={'header'}>
                            <Icon name={'x'} onClick={closeDrawer} />
                            <VWAFilterCount />
                        </div>
                        <SaleMobileSort
                            sortValue={sortValue}
                            options={sortOptions}
                            closeModal={closeDrawer}
                            setSort={setSort}
                        />
                        <FilterMenu
                            useAlias={true}
                            defaultExpandedFilters={defaultExpandedFilters}
                            className="v2"
                            isV2={true}
                            align={'right'}
                        />
                    </>
                );
            }}
        </SearchDrawer>
    );
}

export default withError(withWindowResize(React.memo(SaleFilters)));
